import { useEffect, useState } from "react"
import googleAds from "./google-ads.png"
import meta from "./meta.png"
import { safetyNetContent } from "./safetyNetContent"

const logos = [googleAds, meta]
const swapMs = 4000
const fadeMs = 700

function prefersReducedMotion() {
  if (typeof window === "undefined" || !window.matchMedia) return false
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}

function LogoCycle() {
  const [index, setIndex] = useState(0)
  const [reduced, setReduced] = useState(prefersReducedMotion)

  useEffect(() => {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)")
    const onChange = () => setReduced(query.matches)
    query.addEventListener("change", onChange)
    return () => query.removeEventListener("change", onChange)
  }, [])

  useEffect(() => {
    if (reduced) return undefined
    const id = window.setInterval(() => {
      setIndex((current) => (current + 1) % logos.length)
    }, swapMs)
    return () => window.clearInterval(id)
  }, [reduced])

  return (
    <span className="relative block h-[142px] w-[168px]" aria-hidden="true">
      {logos.map((src, logoIndex) => (
        <img
          key={src}
          src={src}
          alt=""
          className="absolute inset-0 h-full w-full object-contain"
          style={{
            opacity: reduced ? (logoIndex === 0 ? 1 : 0) : logoIndex === index ? 1 : 0,
            transition: reduced ? "none" : `opacity ${fadeMs}ms ease-in-out`,
          }}
        />
      ))}
    </span>
  )
}

export default function SafetyNetSection() {
  return (
    <section className="flex w-full flex-col items-center gap-16 py-16 text-center md:flex-row md:justify-center md:gap-20 md:py-24 md:text-left lg:w-[calc(100vw-3rem)] lg:gap-24 lg:py-0">
      <div className="flex justify-center md:w-[200px] md:justify-end">
        <LogoCycle />
      </div>
      <div className="flex w-full max-w-[640px] flex-col items-center md:items-start">
        <div className="flex flex-col gap-3">
          <h2 className="text-balance text-[48px] font-bold leading-[56px] tracking-[-0.04em] text-[#171717] max-md:text-[32px] max-md:leading-10">
            {safetyNetContent.title}
          </h2>
          <div className="flex flex-col gap-6">
            {safetyNetContent.paragraphs.map((paragraph) => (
              <p
                key={paragraph}
                className="text-balance text-[16px] font-normal leading-6 text-[#4D4D4D] md:text-[18px] md:leading-7 lg:text-[20px] lg:leading-8"
              >
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
